export default __webpack_public_path__ + "static/media/airplay.fb5ecc78.svg";